import Vue from 'vue'
import { formatPrice } from 'lib/util'
import state from 'lib/appState'
import { mapMutations } from 'vuex'
import Cart from 'lib/cart'
import request from 'axios'
Vue.component('free-gift', {
  props: [
    'goal'
  ],
  data () {
    return {
      state,
      contentPrice: ''
    }
  },
  methods: {
    ...mapMutations(['toggleMiniCart']),
    initFreeGift () {
      const freeGiftVariantId = state.freeGiftVariantId
      const cartItems = state.cart.items
      const freeGiftTotalGoal = state.cart.total_price
      const freeGiftGoal = state.freeGiftGoal
      const freeGiftType = state.freeGiftType

      if (freeGiftVariantId > 0 && freeGiftType === 'goal') {
        const result = cartItems.find(product => product.id === freeGiftVariantId)
        const updates = {
          [`${freeGiftVariantId}`]: result ? 1 : 0
        }
        if (freeGiftTotalGoal >= freeGiftGoal) {
          updates[freeGiftVariantId] = 1
        }

        if (!result && updates[freeGiftVariantId] === 0) return null
        if (result && updates[freeGiftVariantId] === result.quantity) return null
        request.post('/cart/update.js', { updates }).then(({ data }) => {
          state.cart = data
        })
      }
    }
  },
  mounted () {
    this.contentPrice = this.$el.getAttribute('data-content')
    this.state.freeGiftVariantId = Number(this.$el.getAttribute('data-product'))
    this.state.freeGiftGoal = this.goal
    this.state.freeGiftType = this.$el.getAttribute('data-type')
    this.initFreeGift()
  },
  computed: {
    isEmpty () {
      return this.state.cart.items.length === 0
    },
    goalReached () {
      return (this.goal <= this.state.cart.total_price)
    },
    goalStarted () {
      return (this.state.cart.total_price > 0)
    },
    progress () {
      return `${(this.state.cart.total_price * 100 / this.goal)}%`
    },
    price () {
      const price = formatPrice(this.goal - this.state.cart.total_price)
      let resultPrice = '$' + price

      if (price % 1 !== 0) {
        resultPrice = this.$options.filters.currency(price, 2)
      }
      return (price > 0) ? resultPrice : '$' + formatPrice(this.goal)
    }
  },
  watch: {
    'state.cart.item_count': {
      handler () {
        this.initFreeGift()
      },
      deep: true
    }
  },
  beforeUpdate () {
    if (this.goalReached && this.$refs.indicator) this.$refs.indicator.style.width = '100%'
  }
})
